import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploader } from 'ng2-file-upload';
import { FormsModule } from '@angular/forms';
import { APP_CONTS } from '../../../app.constants';
import { ImageResizeService } from '../../../services/image-resize.service';
import { forkJoin } from 'rxjs/observable/forkJoin';

import { Adjunto } from '../../../../model/class/Adjunto';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-adjunto',
  templateUrl: './edit-adjunto.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./edit-adjunto.component.css']
})
export class EditAdjuntoComponent implements OnInit {

  newAdjunto: Adjunto;
  editando = false;

  loaders = {
    image: false
  };

  imageFormat = APP_CONTS.FILES.IMAGE_FORMAT_STR;

  public uploader: FileUploader = new FileUploader({
    allowedMimeType:  APP_CONTS.FILES.IMAGE_FORMAT
  });

  @Input()
  set adjunto(adjunto: Adjunto) {
    if (adjunto.id > 0) {
      this.editando = true;
    }

    this.newAdjunto = adjunto;
  }

  constructor(
    public activeModal: NgbActiveModal,
    private imageResizeService: ImageResizeService
  ) {
  }

  ngOnInit() {
  }


  onSubmit() {
    this.activeModal.close(this.newAdjunto);
  }

  asigneImage(event: any) {
    if (this.uploader.queue[this.uploader.queue.length - 1]) {
      const file = this.uploader.queue[this.uploader.queue.length - 1]._file;
      if (file) {
        this.loaders.image = true;
        this.newAdjunto.nuevaImagen = file;
        this.imageResizeService.resize([file], 1024, 768)
          .subscribe((result) => {
            this.loaders.image = false;
            const reader = new FileReader();
            reader.onload = (e: any) => {
              this.newAdjunto.imagen = e.target.result;
            };
            reader.readAsDataURL(result);
        });
      }
    } else {
      console.log('Archivo no valido');
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/edit-adjunto/edit-adjunto.component.ts